import { configureStore } from "@reduxjs/toolkit";
import rootReducer from "./rootReducer";

import {
  persistStore,
  persistReducer,
  FLUSH,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
  REHYDRATE,
  createMigrate,
} from "redux-persist";
import storage from "redux-persist/lib/storage"; // defaults to localStorage for web
import { LabelOption } from "../../types";

const migrations = {
  // migrate label type
  0: (state: any) => {
    const oldEntities = state?.document?.fibonaccis?.entities;
    if (oldEntities) {
      let entitiesEntries = Object.entries(oldEntities) as [string, any][];

      entitiesEntries = entitiesEntries.map(([id, fibo]: [string, any]) => {
        if (fibo.type === 1) {
          fibo.label = [
            { ...fibo.label.left, labelType: LabelOption.ARROWS_CENTER_TEXT },
            { ...fibo.label.right, labelType: LabelOption.ARROWS_CENTER_TEXT }
          ]
        } else {
          fibo.label = [{ ...fibo.label, labelType: LabelOption.ARROWS_CENTER_TEXT }]
        }

        return [id, fibo]
      })

      return {
        document: {
          ...state.document,
          fibonaccis: {
            ...state.document.fibonaccis,
            entities: Object.fromEntries(entitiesEntries)
          }
        },
        ...state
      }
    }

    return state
  }
}

const persistConfig = {
  key: "root",
  storage,
  whitelist: ["document", "uiState"],
  migrate: createMigrate(migrations, { debug: false }),
  version: 1
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
});

if (process.env.NODE_ENV === "development" && module.hot) {
  module.hot.accept("./rootReducer", () => {
    const newRootReducer = require("./rootReducer").default;
    store.replaceReducer(persistReducer(persistConfig, newRootReducer));
  });
}

export const persistor = persistStore(store);

export type RootState = ReturnType<typeof store.getState>;
